import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { ContactAutocompleteService, ContactAutocompleteResult, ContactDetails } from 'src/app/services/contacts/contact-autocomplete.service';
import { IAddressOption } from 'src/app/freightmancerlvl99/freightmancerlvl99.models';


@Component({
  selector: 'app-pool-client-add-modal',
  templateUrl: './pool-client-add-modal.component.html',
  styleUrls: ['./pool-client-add-modal.component.scss']
})
export class PoolClientAddModalComponent {
  clientForm!: FormGroup;

  constructor(
    private fb: FormBuilder, 
    private dialogRef: MatDialogRef<PoolClientAddModalComponent>, 
    private contactSvc: ContactAutocompleteService,
    private http: HttpClient,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: { poolPointUuid: string}
  ){
    console.log('Modal got data: ', data);
  }

  ngOnInit(){
    this.clientForm = this.fb.group({
      pool_point_client_name: ['', Validators.required],
      pool_point_client_contact_uuid: ['', Validators.required],
      pool_point_client_contact_text: [''],
    });
  }

  get poolPointClientContactControl(){
    return this.clientForm.get('pool_point_client_contact_text') as FormControl;
  }

  onClientSelected(selected: ContactAutocompleteResult){
    this.clientForm.patchValue({
      pool_point_client_contact_uuid: selected.value
    });
  }

  close(){
    this.dialogRef.close();
  }

  submit(){
    const url = '/api/pool_points/pool_point_clients.php';
    const postBody = {
      pool_point_uuid: this.data.poolPointUuid,
      pool_point_client_name: this.clientForm.get('pool_point_client_name')?.value,
      pool_point_client_contact_uuid: this.clientForm.get('pool_point_client_contact_uuid')?.value
    }

    this.http.post<any>(url, postBody).subscribe(
      response => {
        if (response.code && response.code === '200'){
          this.toastr.success('Client added.');
        }
        else{
          this.toastr.error('Client not added.');
        }
        console.log(response);
      }, 
      error => {
        this.toastr.error('Client not added');
        console.error(error);
      }
    )
    this.close();
  }
}
